export default {"src":"/_next/static/media/icon-retail.f3bbecc8.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};